<template>
  <div class="vue-wrapper">
    <form class="topbar-search" autocomplete="off" :class="{ 'active': query !== '' }" @submit.prevent="handleSearchSubmit">
      <div class="input-container search" :class="{ 'search-active': query !== '' }">
        <input id="topbar-search-input" @blur="onBlur" autocomplete="off" class="rounded" v-model.trim="query" type="text" placeholder="Søk…" :style="{ 'background-color': avantiEnv === 'staging' ? '#fff' : 'transparent' }">

        <div class="search-category-picker has-popover" :class="{'popover-active': searchTypePopoverActive}">
          <button type="button" @click="toggleSearchTypePopover()" class="search-category-picker-button"><span>Objekt</span> <svg width="5px" height="10px" viewBox="0 0 5 10"><use xlink:href="/static/sprites.svg#glyph-input-select-small"></use></svg></button>
          <span class="popover radio align-x-center align-y-bottom large">
            <ul>
              <li v-for="typeItem in searchTypeOptions" v-bind:key="'type-' + typeItem.type" :class="{ 'active': typeItem.type === 'objekt' }">
                <a href="javascript:;" @click="changeSearchType(typeItem)">
                  <span class="radio-glyph"></span>
                  <span class="radio-title">{{typeItem.name}}</span>
                </a>
              </li>
            </ul>
          </span>
        </div>

        <button class="glyph-button" type="submit">Søk <svg width="14px" height="14px" viewBox="0 0 14 14"><use xlink:href="/static/sprites.svg#glyph-input-search"></use></svg></button>
        <a href="javascript:;" class="cancel-search" @click="clearSearch"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
      </div>
    </form>

    <span class="divider"></span>

    <ul class="button-group">
      <li>
        <span title="Organiser kolonner" class="button-container has-popover" :class="{'popover-active': colPopoverActive}">
          <span class="button action small glyph glyph-only" @click="toggleColPopover()">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-table"></use></svg>
          </span>
          <span class="popover popover-has-header popover-has-footer sortable align-x-center align-y-bottom large">
            <div class="popover-header"><span class="title">Organiser kolonner</span></div>
            <div class="custom-scrollbar">
              <draggable tag="ul" handle=".handle" :value="selectedColumns" @change="onDragChange">
                <li v-for="(column, index) in selectedColumns" v-bind:key="index" :class="{'disabled': !column.selected, 'inactive': !column.selected}">
                  <TheSwitchInputPopoverDragable v-if="!column.readonly" v-model="column.selected" :label="column.name" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                </li>
              </draggable>
            </div>
            <div class="popover-footer">
              <span class="button primary transparent tiny" @click="resetColumns()">Tillbakestill</span>
              <span class="button primary tiny" @click="saveColumns()">Lagre</span>
            </div>
          </span>
        </span>
      </li>
      <li>
        <span title="Visningssvalg" class="button-container has-popover" id="table-thumbnails-popover" :class="{'popover-active': imgPopoverActive}">
          <span class="button action small glyph glyph-only" @click="toggleImgPopover()">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-image"></use></svg>
          </span>
          <span class="popover popover-has-header radio align-x-center align-y-bottom medium">
            <div class="popover-header"><span class="title">Visningssvalg</span></div>
            <ul>
              <li v-for="(imagesize, index) in selectedImageSizes" v-bind:key="imagesize.key" :class="{'active': imagesize.selected}">
                <a href="javascript:;" @click="saveImageSizes(index, imagesize.key)">
                  <span class="radio-glyph"></span>
                  <span class="radio-title">{{imagesize.name}}</span>
                </a>
              </li>
            </ul>
          </span>
        </span>
      </li>
    </ul>

    <a href="javascript:;" @click="exportCsv()" title="Eksporter CSV" class="button action small glyph glyph-only">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
    </a>

    <span class="divider"></span>

    <span class="search-filter-info">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-filter"></use></svg>
      {{filterCount}} filter aktivert
    </span>

    <span class="divider" style="margin-left: 1rem;"></span>

    <span class="search-filter-info" v-if="sums.fetched">
       Antall objekter: {{sums.hits | thousands}}, Sum vurdering lav: {{sums.vurd | thousands}}kr
    </span>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import draggable from 'vuedraggable'

const swapArrayElements = function (array, index1, index2) {
  array[index1] = array.splice(index2, 1, array[index1])[0]
  return array
}

export default {
  name: 'TheSearchObjectTopbar',
  components: {
    draggable
  },
  data () {
    return {
      query: '',
      colPopoverActive: false,
      imgPopoverActive: false,
      searchTypePopoverActive: false,
      searchTypeOptions: [
        { type: '', name: 'Søk i alt' },
        { type: 'objekt', name: 'Objekt' },
        { type: 'kunde', name: 'Kunde' },
        { type: 'kunstner', name: 'Kunstner register' },
        { type: 'faktura', name: 'Faktura' },
        { type: 'kontrakt', name: 'Kontrakt' }
      ],
      selectedColumns: [],
      selectedImageSizes: [],
      sums: {
        fetched: false,
        hits: 0,
        vurd: 0
      }
    }
  },
  created () {
    bus.$off('advanced-objekt-search-info')

    // Remove popover on click outside...
    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.colPopoverActive = false
        vm.imgPopoverActive = false
        vm.searchTypePopoverActive = false

        // To close the objekt popover in SearchObject.vue
        bus.$emit('close-object-search-popover')
      }
    })

    // Add our model for selected columns
    this.selectedColumns = this._.cloneDeep(this.columns)
    this.selectedImageSizes = this._.cloneDeep(this.imagesizes)

    const q = sessionStorage.objectSearchQuery || null

    // Also set query
    if (q) {
      this.query = q
    }
  },
  mounted () {
    bus.$on('advanced-objekt-search-info', (data) => {
      this.onObjectSearchInfo(data)
    })
  },
  computed: {
    imagesizes: function () {
      return this.$store.getters['objectsearch/imagesizes']
    },
    columns: function () {
      return this.$store.getters['objectsearch/columns']
    },
    filterCount: function () {
      return this.$store.getters['objectsearch/filterCount']
    }
  },
  methods: {
    onObjectSearchInfo: function (data) {
      if (data) {
        this.sums.fetched = true
        this.sums.hits = data.hits || 0
        this.sums.vurd = data.sums || 0
      } else {
        this.sums.fetched = false
        this.sums.hits = 0
        this.sums.vurd = 0
      }
    },
    // See: https://github.com/SortableJS/Vue.Draggable
    onDragChange: function (event) {
      if (event.moved) {
        let x = event.moved.oldIndex
        let y = event.moved.newIndex

        // Update array, move and shift down or up...
        if (x > y) {
          for (let i = x; i > y; --i) {
            this.selectedColumns = swapArrayElements(this.selectedColumns, i, i - 1)
          }
        } else {
          for (let i = x; i < y; ++i) {
            this.selectedColumns = swapArrayElements(this.selectedColumns, i, i + 1)
          }
        }
      }
    },
    saveColumns: function () {
      this.$store.dispatch('objectsearch/saveColumns', this.selectedColumns)
        .then(() => {
          this.selectedColumns = this._.cloneDeep(this.columns)
          this.colPopoverActive = false

          bus.$emit('advanced-objekt-search-after-column-update')
        })
    },
    resetColumns: function () {
      this.$store.dispatch('objectsearch/resetColumns')
        .then(() => {
          this.selectedColumns = this._.cloneDeep(this.columns)
          this.colPopoverActive = false

          bus.$emit('advanced-objekt-search-after-column-update')
        })
    },
    saveImageSizes: function (index, key) {
      this.selectedImageSizes.forEach(element => {
        this.$set(element, 'selected', element.key === key)
      })

      this.$store.dispatch('objectsearch/saveImageSizes', this.selectedImageSizes)
        .then(() => {
          this.selectedImageSizes = this._.cloneDeep(this.imagesizes)
          this.imgPopoverActive = false

          bus.$emit('advanced-objekt-search-after-column-update')
        })
    },
    toggleColPopover: function () {
      if (!this.colPopoverActive) {
        this.colPopoverActive = true
        this.imgPopoverActive = false
        this.searchTypePopoverActive = false
      } else {
        this.colPopoverActive = false
        this.imgPopoverActive = false
        this.searchTypePopoverActive = false
      }
    },
    toggleImgPopover: function () {
      if (!this.imgPopoverActive) {
        this.imgPopoverActive = true
        this.colPopoverActive = false
        this.searchTypePopoverActive = false
      } else {
        this.imgPopoverActive = false
        this.colPopoverActive = false
        this.searchTypePopoverActive = false
      }
    },
    toggleSearchTypePopover: function () {
      // If search not active and you try to show search type popover
      if (!this.searchTypePopoverActive) {
        this.searchTypePopoverActive = true
        this.imgPopoverActive = false
        this.colPopoverActive = false
      } else {
        this.searchTypePopoverActive = false
        this.imgPopoverActive = false
        this.colPopoverActive = false
      }
    },
    changeSearchType: function (typeItem) {
      this.searchTypePopoverActive = false

      if (typeItem.type === 'objekt') {
        if (this.query) {
          this.handleSearchSubmit()
        }
      } else if (typeItem.type === 'kunde') {
        // Go to the new search if kunde searching...
        const paramQuery = this.query ? this.query.trim() : null

        if (paramQuery) {
          sessionStorage.customerSearchQuery = paramQuery
        } else {
          sessionStorage.removeItem('customerSearchQuery')
        }

        this.$router.push({
          name: 'SearchCustomer'
        })
      } else {
        // Read in TheMainSearch.vue file...
        sessionStorage.setItem('search-changed', JSON.stringify({
          q: this.query || '',
          t: typeItem.type || ''
        }))

        this.$router.push({
          name: 'Dashboard',
          params: this.$route.params,
          query: {
            search: true,
            advanced: false
          }
        })
      }
    },
    handleSearchSubmit: function () {
      bus.$emit('advanced-objekt-search-start', { query: this.query })
    },
    onBlur: function () {
      this.$store.dispatch('objectsearch/saveQuery', this.query)
    },
    clearSearch: function () {
      this.query = null
      bus.$emit('advanced-objekt-search-clear-search')
    },
    clearFilter: function () {
      bus.$emit('advanced-objekt-search-clear-filter')
    },
    exportCsv: function () {
      bus.$emit('advanced-objekt-search-export')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Search/TheSearchObjectTopbar.vue